import '@/view/dispatch_test/drag_tree/drag_tree.less';
//引入组件
//头部搜索框
import top_search_auto from "@/view/dispatch_test/drag_tree/componets/top_search_auto";

import MeTree from "@/view/dispatch_test/index/components/ra_tree";
import unassigned_task from "@/view/dispatch_test/index/components/unassigned_task";
import changetaskImg from '@/view/dispatch_test/drag_tree/drag_tree_js/change_tasks_img'
import data from "@/view/dispatch_test/index/index_js/data";
import {assignTasks,searchDriverDetial} from "@/api/dispatch";
import {deleteTaskList} from "@/api/tasks";
import baseCounter from "@/view/dispatch_test/countDown"
import taskDetial from "@/components/taskDetial";
import store from "@/store/index";

export default {
  name: "dragTree",
  components: {
    baseCounter,top_search_auto, MeTree,unassigned_task,taskDetial,
  },
  props: {
    tasks: {
      type: Array,
      default: () => []
    },
    nodeKey: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {...data}
  },
  created() {
  },
  methods: {
    clickHandle(detial){
      if (detial.worker_id){
        this.$emit('openDriverInfo',detial)
      }else {
        this.$emit('findMarker',detial.task_id,detial)
      }
    },
    //查看司机详情
    showDetialDrover(driver){
      searchDriverDetial({
        id:driver.id
      }).then(res=>{
        if (res.code == 200){
          // console.log(res.data)
          this.driver_detial_data = res.data
          this.driverDdetialDialog = true
        }
      })
    },
    //搜索后 打开任务详情
    openSearchDetial(i){
      this.info = i
      this.detialDialog = true
      setTimeout(()=>{
        this.$refs.taskDetialRef.getData(i.id)
      })
    },
    //监听拖拽的新任务
    dropStartNewTask(item) {
      this.newTask = { ...item }
    },
    //新任务已经被部署完成，删除新任务组中对应的数据
    dropNewTaskCompleted(item) {
      //移除已经部署好的新任务  删除未指派任务
      this.newTask = {}
    },
    //从树中拖拽的任务开始
    dropStartMeTree(item) {
      this.dropTreeTask = { ...item }
    },
    //树中拖拽任务已经执行drop操作
    dropMeTreeCompleted() {
      this.$refs.unassigned_task.drop()
      this.dropTreeTask = {}
    },
    //新任务拖拽框drop事件触发，拖拽完成 从树拖拽到unassigned_list
    dropCompleted() {
      if (this.dropTreeTask.id !== '' && this.dropTreeTask.id !== undefined) {
        let arr = []
        arr.push(this.dropTreeTask.task_id)
        assignTasks({
          tasks:arr,
          worker_id:'',
          team_id:'',
        }).then(res=>{
          if (res.code == 200){
            this.dropLeaveTreeTask = { ...this.dropTreeTask }
            this.dropTreeTask = {}
          }else{
            this.$message({
              type:"error",
              message:res.msg
            })
          }
        })
      }
    },
    changeAssignList(a){
      this.activeTitlfe = a
    },
    resaveTabList(){
      this.tabList.forEach((item)=>{
        if (this.activeName == item.name){
          if (item.data.length == 0){
            item.count = 0
          }else {
            item.count= 0
            item.data.forEach(v=>{
              if (v.type =='all'){
                item.count = item.count +2
              }else {
                item.count = item.count +1
              }
            })
          }
        }
      })
    },
    confirmDelete(){
      if (this.task_delete_type == 0){
        this.deleteTask(this.delete_data)
      }else if (this.task_delete_type == 1) {
        this.unassignData(this.delete_data)
      }
    },

    //未分配任务右键点击事件
    rightClick(x,y, task) {
      task.status = 0
      this.taskMenu.x = x;
      this.taskMenu.y = y;
      //点击未分配任务的类型是unAssigned
      this.taskMenu.taskType = 'unAssigned';
      this.taskMenu.task = task;
    },
    rightClicks(event, task) {
      let x = event.clientX;
      let y = event.clientY;
      this.taskMenu.x = x;
      this.taskMenu.y = y;
      this.taskMenu.task = task;
      //点击已分配任务的类型是assigned
        this.taskMenu.taskType = 'assigned';
        this.deleteTaskType = task.type
      // console.log(this.taskMenu)
    },
    rightCliksDriver(event,driver){
      let x = event.clientX;
      let y = event.clientY;
      this.taskMenu.x = x;
      this.taskMenu.y = y;
      this.taskMenu.task = driver;
      this.taskMenu.taskType = 'driver';
      // console.log(this.taskMenu,'driver')
    },
    //删除任务
    deleteTask(a) {
      //需要分辨是从 assigned 还是 unassigned 点击的删除
      let id = ""
      this.deleteDialog = false
      if (a.index_id){
        id = a.index_id
      }else {
        id =a.id
      }
      this.deleteHandle(id,a)
    },
    deleteHandle(id,a){
      deleteTaskList({
        id:id,
      }).then(res => {
        this.closeMenu()
        if (res.code == 200) {
          this.$message({
            message: 'Deleted successfully',
            type: 'success'
          });
        } else {
          this.$message({
            message: res.msg,
            type: 'warning'
          });
        }
      })
    },
    //将已经分配的任务 设置成未分配
    unassignData(e){
      this.deleteDialog = false
      let tasks = []
      tasks.push(e.task_id)
      assignTasks({
        tasks:tasks,
        worker_id:'',
        team_id:'',
      }).then(res=>{
        if (res.code == 200){
          this.$message({
            type: 'success',
            message:'Unassigned successfully'
          })
        }else {
          this.$message({
            type: 'warning',
            message:res.msg
          })
        }
      })
    },
    /**
     * 关闭所有右键弹框
     */
    closeMenu() {
      store.state.map_draw_line_arr = []
      this.taskMenu.task = null
      const menus = document.getElementsByClassName('contextmenu')
      for (let i = 0; i < menus.length; i++) {
        menus[i].style.display = 'none'
      }
      this.inSourceLists.forEach((v, index) => {
        this.$set(this.inSourceLists[index], 'show', false)
      })
      this.shList.forEach((v, index) => {
        this.$set(this.shList[index], 'showViwer', false)
      })
    },
    //查看详情
    showDetial(i) {
      i.tasksId = i.task_id
      i.is_hub = 0
      this.info = i
      this.detialDialog = true
      setTimeout(() => {
        this.$refs.taskDetialRef.getData(i.id)
      }, 100)
    },
    closeTaskDetial(){
      this.detialDialog = false
    },
    //打开弹框
    openDeleteDialog(a,type,n){
      this.$emit('openDeleteDialog',a,type,n)
      if (n == 0){
        this.deleteTitle = 'Delete task'
        this.task_delete_type = 0
      }else {
        //unassigned
        this.deleteTitle = 'Unassign task'
        this.task_delete_type = 1
      }
      this.task_invoice_number =a.invoice_number
      this.delete_data = a
      this.task_type= type
      this.deleteDialog = true
    },
    //将毫秒转化成时分秒
    formatTime(msTime) {
      let time = msTime ;
      let day = Math.floor(time /60 /60 /24);
      let hour = Math.floor(time /60 /60) %24;
      let minute = Math.floor(time /60) %60;
      let second = Math.floor(time) %60;
      return `${hour} h ${minute} mins`
    },

  },
  destroyed() {
  }
}
